import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { SCOPES } from '../scopes';
import { ThemeToggle } from './ThemeToggle';
import { TrashIcon } from './TrashIcon';

interface Props {
  counts?: Partial<Record<string, number>>;
  onNavigate?: () => void;
}

export function ScopeSidebar({ counts, onNavigate }: Props) {
  const { user, signOut } = useAuth();

  return (
    <nav className="scope-sidebar" aria-label="Scopes">
      <div className="scope-brand">
        <h2>Tasks</h2>
      </div>

      <ul className="scope-list">
        <li>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')} onClick={onNavigate}>
            <span className="scope-swatch" style={{ backgroundColor: '#f59e0b' }} />
            <span className="scope-label">Combined</span>
            {counts?.inbox ? <span className="scope-count">{counts.inbox}</span> : null}
          </NavLink>
        </li>
        {SCOPES.map((s) => (
          <li key={s.id}>
            <NavLink
              to={`/scope/${s.slug}`}
              className={({ isActive }) => (isActive ? 'active' : '')}
              onClick={onNavigate}
            >
              <span className="scope-swatch" style={{ backgroundColor: s.color }} />
              <span className="scope-label">{s.label}</span>
              {counts?.[s.id] ? (
                <span className="scope-count">{counts[s.id]}</span>
              ) : null}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="scope-sidebar-footer">
        <NavLink
          to="/private"
          className={({ isActive }) => `private-link ${isActive ? 'active' : ''}`}
          title="Tasks only you can see"
          onClick={onNavigate}
        >
          <span className="private-icon" aria-hidden="true">🔒</span>
          <span className="scope-label">Private</span>
        </NavLink>
        <NavLink
          to="/completed"
          className={({ isActive }) => `completed-link ${isActive ? 'active' : ''}`}
          onClick={onNavigate}
          title="Recently completed tasks (last 30 days)"
        >
          <span className="private-icon" aria-hidden="true">✓</span>
          <span className="scope-label">Completed</span>
        </NavLink>
        <NavLink
          to="/trash"
          className={({ isActive }) => `trash-link ${isActive ? 'active' : ''}`}
          onClick={onNavigate}
        >
          <TrashIcon />
          <span className="scope-label">Trash</span>
        </NavLink>
        <ThemeToggle />
        {user && (
          <button className="signout-btn" onClick={signOut} title={user.email}>
            Sign out
          </button>
        )}
      </div>
    </nav>
  );
}
